import React from 'react';
import { Slide } from 'pure-react-carousel';
import { getEmptySlidesCount } from '../utils';
export var EmptySlides = function (_a) {
    var slidesLength = _a.slidesLength, visibleSlidesCount = _a.visibleSlidesCount;
    var slides = [];
    var missingSlidesCount = getEmptySlidesCount(slidesLength, visibleSlidesCount);
    for (var i = 0; i < missingSlidesCount; i++) {
        slides.push(React.createElement(Slide, { index: slidesLength + i + 1, key: slidesLength + i + 1 }, null));
    }
    return React.createElement(React.Fragment, null, slides);
};
//# sourceMappingURL=EmptySlides.js.map